import { Nullable } from 'models/shared.models'
import { InvoiceForm, Tax } from 'models/invoices.models'
import { IInvoiceCreationRequest } from './invoices.models'

export const createInvoiceCreationRequestBody = (
  form: InvoiceForm,
  draft?: boolean
): Nullable<IInvoiceCreationRequest> => {
  return {
    additionalInformation: form.condiciones,
    clientId: form.receptor?.id ?? null,
    concept: form.conceptos.map(
      ({
        cantidad,
        claveSat,
        claveUnitSat,
        description,
        impuestos,
        objImp,
        price,
        satKey,
        uuid,
      }) => ({
        objImp: objImp?.idCatalogValues,
        satKey: satKey?.idCatalogValues ?? claveSat?.idCatalogValues,
        unit: claveUnitSat?.idCatalogValues,
        price,
        amount: cantidad,
        description,
        tax: (impuestos as Tax[]).map(impuesto => {
          return {
            impuesto: impuesto.id,
            rate: impuesto.selectedValue,
            uuid: impuesto.uuid,
          }
        }),
        uuid,
      })
    ),
    currencyId: form.moneda?.idCatalogValues ?? null,
    emisorId: form.emisor?.idRfc ?? null,
    exchangeRate: form.tipoCambio,
    folio: !draft ? form.folio : '',
    idPeriodicity: form.period?.idCatalogValues ?? null,
    idPMonth: form.month?.idCatalogValues ?? null,
    idRequest: form.idRequest ?? null,
    idType: form.tipo?.idCatalogValues ?? null,
    idUsoCfdi: form.usoCfdi?.idCatalogValues ?? null,
    paymenteMethodId: form.metodoPago?.idCatalogValues ?? null,
    periodicityYear: !isNaN(Number(form.year?.value))
      ? Number(form.year?.value)
      : null,
    serie: !draft ? form.serie?.value ?? null : null,
    version: form.version,
    wayOfPaymentId: form.formaPago?.idCatalogValues ?? null,
  }
}
